<template>
  <v-container>
    <v-overlay :absolute="absolute" :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col>
        <v-banner elevation="1">Horarios</v-banner>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-center">
          <v-text-field
            label="Buscar"
            placeholder="Horario..."
            v-model="searchSchedules"
            @keyup="filterSchedules()"
          ></v-text-field>
        </div>
      </v-col>
      <v-col>
        <div class="text-center float-right">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                fab
                small
                icon
                @click="showNew()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-av-timer
                </v-icon>
              </v-btn>
            </template>
            <span>Agregar Horario</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet elevation="1">
          <v-progress-linear
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-linear>
          <v-simple-table cols="auto" elevation="9">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    Nombre
                  </th>
                  <th class="text-center">
                    Inicio
                  </th>
                  <th class="text-center">
                    Fin
                  </th>
                  <th class="text-center">
                    Opciones
                  </th>
                </tr>
              </thead>
              <template v-if="schedules.length">
                <tbody>
                  <tr
                    class="text-center"
                    v-for="schedule in schedules"
                    :key="schedule.id"
                  >
                    <td>{{ schedule.name }}</td>
                    <td>{{ schedule.schedule_start }}</td>
                    <td>{{ schedule.schedule_end }}</td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            fab
                            small
                            icon
                            @click="showDelete(schedule)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <div class="float-right pa-4">
                  No hay registros
                </div>
              </template>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogDelete" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Eliminar Horario</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          ¿está seguro que desea eliminar el horario {{ scheduleDelete.name }}?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogDelete = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="warning float-right"
            text
            @click="deleteSchedule(scheduleDelete)"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNew" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Crear Horario:</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-form v-model="validNew">
            <v-container>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-text-field
                    v-model="scheduleNew.name"
                    :rules="scheduleRules"
                    :counter="24"
                    label="Nombre"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-dialog
                    ref="dialog"
                    v-model="modal_start"
                    :return-value.sync="scheduleNew.start"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="scheduleNew.start"
                        label="Hora de inicio"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="modal_start"
                      v-model="scheduleNew.start"
                      full-width
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal_start = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(scheduleNew.start)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-8 pt-6">
                  <v-dialog
                    ref="dialog2"
                    v-model="modal_end"
                    :return-value.sync="scheduleNew.end"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="scheduleNew.end"
                        label="Hora final"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="modal_end"
                      v-model="scheduleNew.end"
                      full-width
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal_end = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog2.save(scheduleNew.end)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialogNew = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary float-right"
            text
            @click="saveScheduleNew()"
            :disabled="!validNew"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="alertSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Config } from "../config";
export default {
  data() {
    return {
      loading: false,
      overlay: true,
      absolute: true,
      scheduleNew: {
        name: "",
        start: null,
        end: null
      },
      modal_start: false,
      modal_end: false,
      scheduleDelete: {},
      dialogNew: false,
      validNew: false,
      alertSnackbar: false,
      snackbarText: "",
      schedules: [],
      searchSchedules: "",
      valid: false,
      show: false,
      scheduleRules: [
        v => !!v || "Este campo no puede estar vacío",
        v => v.length >= 4 || "Este campo debe ser mayor a 4 caracteres",
        v => v.length <= 25 || "Este campo debe ser menor a 24 caracteres"
      ],
      dialogDelete: false
    };
  },
  mounted() {
    this.getSchedules();
  },
  computed: {},
  methods: {
    getSchedules() {
      this.overlay = true;
      let url = Config.url + "/db/schedules";
      this.axios
        .get(url)
        .then(res => {
          this.schedules = res.data.schedules;
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Error en servidor, falló al tratar de obtener lista de horarios";
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showNew() {
      this.dialogNew = true;
    },
    showDelete(schedule) {
      this.dialogDelete = true;
      this.scheduleDelete = schedule;
    },
    deleteSchedule(schedule) {
      this.overlay = true;
      this.dialogDelete = false;
      let url = Config.url + "/db/schedule";
      let params = {
        id: schedule.id
      };
      this.axios
        .delete(url, { params: params })
        .then(res => {
          if (res.status == 200) {
            this.snackbarText = "Horario eliminado exitosamente";
            this.alertSnackbar = true;
            this.getSchedules();
          }
        })
        .catch(err => {
          console.log(err);
          this.snackbarText =
            "Ocurrió un error al eliminar horario, intente más tarde";
          this.alertSnackbar = true;
          this.getSchedules();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    validateSchedule() {
      let start = this.scheduleNew.start.replace(":", "");
      let end = this.scheduleNew.end.replace(":", "");
      if (start > end) {
        return false;
      } else {
        return true;
      }
    },
    saveScheduleNew() {
      if (this.validateSchedule()) {
        this.overlay = true;
        this.dialogNew = false;
        let url = Config.url + "/db/schedule";
        let params = {
          name: this.scheduleNew.name,
          schedule_start: this.scheduleNew.start,
          schedule_end: this.scheduleNew.end
        };
        this.axios
          .post(url, params)
          .then(res => {
            if (res.status == 201) {
              this.snackbarText = "Horario guardado exitosamente";
              this.alertSnackbar = true;
              this.scheduleNew = {
                name: "",
                start: "",
                end: ""
              };
              this.getSchedules();
            }
          })
          .catch(err => {
            if (err.response.status == 409) {
              this.snackbarText = `scheduleo ${this.scheduleNew.name} ya existe`;
            } else {
              this.snackbarText =
                "Ocurrió un error al guardar este horario, es posible que ya exista un horario con esta hora/nombre";
            }
            this.alertSnackbar = true;
            this.getSchedules();
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.snackbarText =
          "La hora de inicio no puede ser mayor a la hora final";
        this.alertSnackbar = true;
      }
    },
    filterSchedules() {
      this.loading = true;
      if (this.searchSchedules != "") {
        let url = Config.url + "/db/schedules";
        this.axios
          .get(url)
          .then(res => {
            this.schedules = res.data.schedules;
            let arrayFilterUsers = [];
            let searchSchedules = this.searchSchedules.toLowerCase();
            this.schedules.map(item => {
              let name = item.name.toLowerCase();
              let start = item.schedule_start.toLowerCase();
              let end = item.schedule_end.toLowerCase();
              if (
                name.search(searchSchedules) != -1 ||
                start.search(searchSchedules) != -1 ||
                end.search(searchSchedules) != -1
              ) {
                arrayFilterUsers.push(item);
              }
            });
            this.schedules = arrayFilterUsers;
          })
          .catch(err => {
            console.log(err);
            this.snackbarText = "Ocurrió un error, intente más tarde";
            this.alertSnackbar = true;
          });
      } else {
        this.getSchedules();
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
